import { html } from "@utils/dom";

export const HIDE_CURSOR_CLASSNAME = '--js-hide-cursor';

export const hideCursor = () => html.classList.add(HIDE_CURSOR_CLASSNAME);
export const showCursor = () => html.classList.remove(HIDE_CURSOR_CLASSNAME);

export default {
  hideCursor,
  showCursor,
};
